import { buildWeeklySchedule } from '../../_lib/detail/formatters';

interface ScheduleTabProps {
  performances: Array<{ dateTime: string }>;
  /** Resolved once by the server and threaded down — see
   *  `formatters.ts`'s `getDefaultSelectedDate` doc comment. */
  todayKey: string;
}

/** Schedule tab — brd-frontend.md §6.2, brd-backend.md §6.1, frd.md
 *  FR-TAB-02. Bold times vs. normal-weight dashes for empty slots; AM/PM
 *  shown alongside every populated time (already baked into
 *  `formatShowtime`). The parent `ShowDetailTabs` decides whether to render
 *  this tab at all via the same `buildWeeklySchedule().hasAny` this
 *  component itself computes — kept in sync since both call the one shared
 *  helper. */
export function ScheduleTab({ performances, todayKey }: ScheduleTabProps) {
  const { days } = buildWeeklySchedule(performances, todayKey);

  return (
    <div className="shows-detail-tab-panel">
      <h4>Schedule</h4>
      <p className="shows-detail-schedule-subhead">Upcoming Performance Times</p>
      <div className="shows-detail-schedule-table-wrap">
        <table className="shows-detail-schedule-table">
          <thead>
            <tr>
              <th>Day of week</th>
              <th>Date</th>
              <th>Matinee</th>
              <th>Evening</th>
            </tr>
          </thead>
          <tbody>
            {days.map((d) => (
              <tr key={d.dayName + d.dateLabel}>
                <td>{d.dayName}</td>
                {/* `dateLabel` was already computed by `buildWeeklySchedule` and used only as part
                    of this row's React `key` — never actually rendered. */}
                <td>{d.dateLabel}</td>
                <td>{d.matinee ? <strong>{d.matinee}</strong> : '-'}</td>
                <td>{d.evening ? <strong>{d.evening}</strong> : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
